/* ps-figscale.js ｜ 固定キャンバスの図解（図解02/03 PCソース統合）を本文カラム幅へ等比縮小する。
   デザインは改変しない（拡大縮小のみ）。PC一巡用。SP版は別データで差し替える。 */
(function () {
  /* v1.8.0 SP PHASE B：固定キャンバスの等比縮小は PC（>=990px）限定。
     SPでは図解02/03のPC縮小流用を禁止しているため、--ps-fig-scale と
     style.height を一切設定せず、SP専用DOM（ps-figure-0X-sp）へ委ねる。 */
  var PC_MQ = window.matchMedia('(min-width: 990px)');

  function isPC() {
    return PC_MQ.matches;
  }

  function reset(frame) {
    frame.style.removeProperty('--ps-fig-scale');
    frame.style.removeProperty('height');
  }

  function apply(frame) {
    if (!isPC()) {
      reset(frame);
      return;
    }
    var w = parseFloat(frame.getAttribute('data-w')) || 0;
    var h = parseFloat(frame.getAttribute('data-h')) || 0;
    if (!w) return;
    var available = frame.clientWidth;
    if (!available) return;
    var scale = Math.min(1, available / w);
    frame.style.setProperty('--ps-fig-scale', String(scale));
    if (h) frame.style.height = Math.round(h * scale) + 'px';
  }

  function init() {
    var frames = document.querySelectorAll('[data-ps-figscale]');
    if (!frames.length) return;
    frames.forEach(apply);

    var onMQ = function () {
      frames.forEach(apply);
    };
    if (typeof PC_MQ.addEventListener === 'function') {
      PC_MQ.addEventListener('change', onMQ);
    } else if (typeof PC_MQ.addListener === 'function') {
      PC_MQ.addListener(onMQ);
    }

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          apply(entry.target);
        });
      });
      frames.forEach(function (frame) {
        ro.observe(frame);
      });
    } else {
      window.addEventListener('resize', function () {
        frames.forEach(apply);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
